export const actionTypes = {
  UPDATE_USER_DETAILS: 'UPDATE_USER_DETAILS',
  UPDATE_MEMBER_DETAILS: 'UPDATE_MEMBER_DETAILS',
  UPDATE_SELECTED_QUOTE: 'UPDATE_SELECTED_QUOTE',
  UPDATE_FULL_QUOTE: 'UPDATE_FULL_QUOTE',
  UPDATE_PROPOSER_DETAILS: 'UPDATE_PROPOSER_DETAILS',
  UPDATE_NOMINEE_DETAILS: 'UPDATE_NOMINEE_DETAILS',
  UPDATE_TOKEN: 'UPDATE_TOKEN',
  UPDATE_TOKEN_MOTOR: 'UPDATE_TOKEN_MOTOR',
  UPDATE_QUICK_QUOTE_FILTERS: 'UPDATE_QUICK_QUOTE_FILTERS',
  UPDATE_PROVIDER_DETAILS: 'UPDATE_PROVIDER_DETAILS',
  UPDATE_SELECTED_FULL_QUOTE: 'UPDATE_SELECTED_FULL_QUOTE',
  UPDATE_TRUST: 'UPDATE_TRUST',
  UPDATE_PAYMENT_LINK: 'UPDATE_PAYMENT_LINK',
  UPDATE_KYC_LINK: 'UPDATE_KYC_LINK',
  UPDATE_PLAN_DETAILS_QUOTE: 'UPDATE_PLAN_DETAILS_QUOTE',
  UPDATE_PLAN_DETAILS: 'UPDATE_PLAN_DETAILS',
  ADD_TO_COMPARE: 'ADD_TO_COMPARE',
  REMOVE_FROM_COMPARE: 'REMOVE_FROM_COMPARE',
  CLEAR_COMPARE_LIST: 'CLEAR_COMPARE_LIST',
  UPDATE_POLICY_TENURE: 'UPDATE_POLICY_TENURE',
  UPDATE_OLD_POLICY_ID: 'UPDATE_OLD_POLICY_ID',
  CLEAR_STATE: 'CLEAR_STATE',
}

export const motorActionTypes = {
  UPDATE_VEHICLE_DETAILS: 'UPDATE_VEHICLE_DETAILS',
  UPDATE_PERSONAL_DETAILS: 'UPDATE_PERSONAL_DETAILS',
  UPDATE_PREVIOUS_POLICY_DETAILS: 'UPDATE_PREVIOUS_POLICY_DETAILS',
  UPDATE_CURRENT_POLICY_DETAILS: 'UPDATE_CURRENT_POLICY_DETAILS',
  UPDATE_SELECTED_QUOTE: 'UPDATE_SELECTED_QUOTE',
  UPDATE_TOKEN_MOTOR: 'UPDATE_TOKEN_MOTOR',
  UPDATE_NOMINEE_DETAILS: 'UPDATE_NOMINEE_DETAILS',
  UPDATE_PA_COVER: 'UPDATE_PA_COVER',
  UPDATE_MOTOR_DETAILS: 'UPDATE_MOTOR_DETAILS',
  UPDATE_IS_VEHICLE_PREFILLED_DATA: 'UPDATE_IS_VEHICLE_PREFILLED_DATA',
}

export const updateTour = {
  START_RISK_SCORE_TOUR: 'START_RISK_SCORE_TOUR',
  START_RISK_SCORE_TOUR_POPUP: 'START_RISK_SCORE_TOUR_POPUP',
  START_POLICY_TILE_CARD_TOUR: 'START_POLICY_TILE_CARD_TOUR',
  START_INSURANCE_DETAILS_TOUR: 'START_INSURANCE_DETAILS_TOUR',
  START_RISK_SCORE_INPUT_TOUR: 'START_RISK_SCORE_INPUT_TOUR',
}

export const notificationActions = {
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
}

export const insuranceProviderActions = {
  INSURANCE_PROVIDER_LIST: 'INSURANCE_PROVIDER_LIST',
}

export const lifeActionTypes = {
  UPDATE_LIFE_USER_DETAILS: 'UPDATE_LIFE_USER_DETAILS',
  UPDATE_LIFE_MEMBER_AGE_DETAILS: 'UPDATE_LIFE_MEMBER_AGE_DETAILS',
  UPDATE_LIFE_SELECTED_QUICK_QUOTE: 'UPDATE_LIFE_SELECTED_QUICK_QUOTE',
  UPDATE_LIFE_PROPOSER_DETAILS: 'UPDATE_LIFE_PROPOSER_DETAILS',
  UPDATE_LIFE_INSURED_MEMBER_DETAILS: 'UPDATE_LIFE_INSURED_MEMBER_DETAILS',
  UPDATE_LIFE_NOMINEE_DETAILS: 'UPDATE_LIFE_NOMINEE_DETAILS',
}

export const buyPolicyActionType = {
  UPDATE_BUY_POLICY_TITLE: 'UPDATE_BUY_POLICY_TITLE',
}
